export default {
  List: {
    Title: "Quản lý người dùng",
    Role: "Vai trò",
    Status: "Trạng thái",
  },
  Table: {
    UserCode: "Mã nhân viên",
    Name: "Họ và tên",
    PhoneNumber: "Số điện thoại",
    Email: "Email",
    Position: "Chức vụ",
    Role: "Vai trò",
    Status: "Trạng thái",
  },
  Confirm: {
    Delete: "Bạn có muốn xóa người dùng ",
  },
};
